import { IonCol, IonGrid, IonRow } from "@ionic/react";
import React from "react";
import "./persona.scss";

export interface IPersonaProps {
  name: string;
  showName?: boolean;
  className?: string;
  manageUsersFlag?: boolean;
  viewProfile?: boolean;
}

export const Persona: React.FunctionComponent<IPersonaProps> = (
  props: IPersonaProps
) => {
  const { name, showName, className = "", manageUsersFlag = false, viewProfile = false } = props;
  let personaName: string = "";
  let fNameToShow: string = "";
  let lNameToShow: string = "";

  if (name) {
    const nameArr: string[] = name.split(" ");
    let bufferName = "";
  
    if (nameArr.length > 0) {
      nameArr.forEach((char, index) => {
        if (char && char !== "" && char !== " ") {
          bufferName += `${char} `
        }
      })
      bufferName = bufferName.trim()
      const bufferNameArr = bufferName.split(" ")

      if (bufferNameArr.length > 0) {
        fNameToShow = bufferNameArr[0];
      }
      if (bufferNameArr.length > 1) {
        for (let index = 1; index < bufferNameArr.length; index++) {
          if(bufferNameArr[index] && bufferNameArr[index] !== "") {
            if (index == 1) {
              lNameToShow = bufferNameArr[index];
            } else {
              lNameToShow += ` ${bufferNameArr[index]}`;
            }
          }
        }
      }
    }

    const firstName: string = fNameToShow.slice(0, 1);
    const lastName: string = lNameToShow.slice(0, 1)

    personaName = firstName.toUpperCase() + lastName.toUpperCase();

  } else {
    personaName = "U";
  }

  return (
    <div className={`persona ${className}`}>
      <IonGrid className="persona-grid">
        <IonRow>
          <IonCol size="auto" className="persona-col">
            <span
              className={`icon-name ${manageUsersFlag ? "persona-name-manage-users" : viewProfile ? "persona-name-view-profile" : "persona-name"}`}
              style={{
                padding: `${personaName.length > 1
                  ? "16px 5px 16px 3px"
                  : "16px 10px 16px 10px"
                  }`,
              }}
            >
              {personaName}
            </span>
          </IonCol>
          <IonCol>
            {showName && (
              <IonCol size="auto" className="persona-name-col">
                <div className="persona-show-name">
                  {fNameToShow}
                </div>
                <div className="persona-show-name">
                  {lNameToShow}
                </div>
              </IonCol>
            )}
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
};
